/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */

/**
 * [getUnixDiff description]
 * @type {[type]}
 */
const getUnixDiff = (targetDate: Date | number) => {
  const unixNow = new Date().getTime()
  let unixTarget = targetDate instanceof Date ? targetDate.getTime() : targetDate
  
  return Math.floor((unixTarget - unixNow) / 1000)
}

/**
 * [calculateDuration description]
 * @type {[type]}
 */
export const calculateDuration = (targetDate: Date | number) => {
    const diff = getUnixDiff(targetDate)
    if (diff <= 0) return 0

    const minutes = Math.floor((diff / 60) % 60)
    const seconds = Math.floor(diff % 60)

    return { minutes, seconds }
  }
